/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_7_QInputs */

const en_cp_faq_7_q = /** @type {(inputs: Cp_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does a team get after finishing?`)
};

const id_cp_faq_7_q = /** @type {(inputs: Cp_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang didapat tim setelah selesai?`)
};

/**
* | output |
* | --- |
* | "What does a team get after finishing?" |
*
* @param {Cp_Faq_7_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_7_q = /** @type {((inputs?: Cp_Faq_7_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_7_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_7_q(inputs)
	return en_cp_faq_7_q(inputs)
});